var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji_objects_24dp_5F6368_FILL1_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 38.5C20.2417 38.5 19.5562 38.3177 18.9437 37.9531C18.3313 37.5885 17.85 37.1 17.5 36.4875C16.5375 36.4875 15.7135 36.1448 15.0281 35.4594C14.3427 34.774 14 33.95 14 32.9875V26.775C12.2792 25.6375 10.901 24.1354 9.86563 22.2687C8.83021 20.4021 8.3125 18.375 8.3125 16.1875C8.3125 12.6583 9.54479 9.66146 12.0094 7.19687C14.474 4.73229 17.4708 3.5 21 3.5C24.5292 3.5 27.526 4.73229 29.9906 7.19687C32.4552 9.66146 33.6875 12.6583 33.6875 16.1875C33.6875 18.4333 33.1698 20.475 32.1344 22.3125C31.099 24.15 29.7208 25.6375 28 26.775V32.9875C28 33.95 27.6573 34.774 26.9719 35.4594C26.2865 36.1448 25.4625 36.4875 24.5 36.4875C24.15 37.1 23.6687 37.5885 23.0562 37.9531C22.4437 38.3177 21.7583 38.5 21 38.5ZM17.5 32.9875H24.5V31.4125H17.5V32.9875ZM17.5 29.6625H24.5V28H17.5V29.6625ZM22.3125 24.5V19.775L26.1625 15.925L24.325 14.0875L21 17.4125L17.675 14.0875L15.8375 15.925L19.6875 19.775V24.5H22.3125Z",
    fill: "#D9E8F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbicon);
export default __webpack_public_path__ + "static/media/light+bulb+icon.5c18c1dddf0c1d6bf3a77686cdfd1758.svg";
export { ForwardRef as ReactComponent };